<script lang="ts">
  import { Checkbox } from '$shared/components';
  import type { CvoStatusUpdateFormModel } from '$shared/models/forms/CvoStatusUpdateFormModel';

  interface Props {
    formData: CvoStatusUpdateFormModel;
    disabled?: boolean;
    children?: import('svelte').Snippet;
  }

  let { formData = $bindable(), disabled = false, children }: Props = $props();
</script>

<div class="cancelled-state">
  <Checkbox
    bind:checked={formData.disableAllMonitorCheck}
    name="monitor-check"
    label={formData.monitorCheckLabel}
    {disabled}
  />
  {@render children?.()}
</div>
